import { render } from "./tubeFLList.vue?vue&type=template&id=883d25d8"
import script from "./tubeFLList.vue?vue&type=script&lang=js"
export * from "./tubeFLList.vue?vue&type=script&lang=js"

import "./tubeFLList.vue?vue&type=style&index=0&id=883d25d8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__